export const FETCH_PLAN_SUBOPTION_LOOKUP_REQUEST = "FETCH_PLAN_SUBOPTION_LOOKUP_REQUEST";
export const FETCH_PLAN_SUBOPTION_LOOKUP_SUCCESS = "FETCH_PLAN_SUBOPTION_LOOKUP_SUCCESS";
export const FETCH_PLAN_SUBOPTION_LOOKUP_FAILURE = "FETCH_PLAN_SUBOPTION_LOOKUP_FAILURE";
